<template>
  <div class="content content--agenda-single">
    <MyHeader :breadcrumbItems="[
        {
          name: pageName.name,
          path: `/${$route.params.companySlug}/agenda`
        },
        {
          name: agenda.title,
          path: $route.path
        },
      ]" />

    <header class="content-header d-lg-none">
      <h1>{{ agenda.title }}</h1>
    </header>

    <div class="container">
      <div class="hero--gtm">
        <div class="hero-img">
          <template v-if="agenda.videoURL && thumbnail">
            <img :src="thumbnail">
            <button class="video-play" @click="openPopup($event, 'video')"><i class="icon-play"></i></button>
          </template>
          <AttachmentLoader v-else-if="agenda.videoURL && !thumbnail"></AttachmentLoader>
          <ImageWrapper v-else :file="agenda.idFile" :key="agenda.idFile"></ImageWrapper>
        </div>
        <div class="hero-content">
          <span class="hero-tag">
            <span>{{agenda.targetAudience}}</span>
<!--            <span>Additional Content</span>-->
          </span>
          <span class="hero-tag"><i class="icon-calendar"></i> <span>{{agenda.startDate | agendaDate(agenda.endDate, agenda.hideTime)}}</span><span>{{type.value}}</span></span>
          <span class="hero-title">{{ agenda.title }}</span>
          <div class="buttons" v-if="agenda.email">
            <button class="button-icon" @click="openPopup($event, 'form')">Any questions? Contact us</button>
            <button class="button-icon" @click="downloadIcs">Add to Calendar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="tabs">
      <div class="tabs-inner">
        <router-link :to="{name: 'AgendaSingleMain'}" exact active-class="active">Main information</router-link>
        <router-link v-if="this.$store.getters.agendaEvent._embedded.AdditionalInformation.length" :to="{name: 'AgendaSingleDetails'}" exact active-class="active">Session Details</router-link>
      </div>
    </div>

    <router-view></router-view>

    <transition name="fade">
      <div class="popup-wrapper" v-if="popupVideo">
        <div class="popup-overlay" @click="closePopup('video')"></div>
        <div class="popup popup--video">
          <button class="popup-close2" @click="closePopup('video')"><i class="icon-close"></i> <span>Close player</span></button>
          <div class="video-box">
            <div class="video-wrapper">
              <video width="100%" height="397" controls>
                <source src="images/sample.mp4" type="video/mp4">
              </video>
              <div class="video-img-wrapper" v-html="openLinksInNewTab(videoIframe)">
                <iframe src="https://player.vimeo.com/video/529336184?h=c52fb833d1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="UGAPAcadmieREPLAYDcouvreznotresavoir-faireEAMGMAO.mp4"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="popup-wrapper" v-if="popupForm">
        <div class="popup-overlay" @click="closePopup('form')"></div>
        <div class="popup popup--form">
          <button class="popup-close" @click="closePopup('form')"></button>
          <div class="form-block">
            <label>Topic</label>
            <input type="text" v-model="contactForm.subject">
          </div>
          <div class="form-block">
            <label>Message</label>
            <textarea placeholder="Start typing..." v-model="contactForm.content"></textarea>
          </div>
          <div class="buttons">
            <button class="button-icon button--submit" @click="sendMessage">Submit <i class="icon-send"></i></button>
            <button class="button" @click="closePopup('form')">Cancel</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {openLinksInNewTab} from "@/helpers/openLinksInNewTab"
import MyHeader from '../../components/general/Header'
import ImageWrapper from "@/components/general/ImageWrapper";
import AttachmentLoader from "@/components/forms/AttachmentLoader";
import settings from "@/settings";
import api from "@/api/sendEmail";
import vimeo from "@/api/external/vimeo";
import moment from "moment-timezone";
const ics = require('ics')
import he from 'he'
import userApi from "@/api/user";
export default {
  name: "AgendaSingle",
  components: {AttachmentLoader, ImageWrapper, MyHeader},
  data () {
    return {
      popupVideo: false,
      popupForm: false,
      thumbnail: '',
      videoIframe: '',
      contactForm: {
        subject: '',
        content: ''
      }
    }
  },
  computed: {
    agenda() {
      return this.$store.getters.agendaEvent
    },
    type() {
      return this.$store.getters.settingsCompanyBySettingTypeCodeAndID(settings.SETTING_TYPES.AGENDA_TYPE, this.agenda.idType)
    },
    pageName() {
      return this.$store.getters.menu().find((item) => {
        return item.routeName === 'Agenda'
      })
    }
  },
  mounted() {
    this.getAgendaEvent()
  },
  watch: {
    '$store.getters.agendaEventLoaded'(val) {
      if(val && this.agenda.videoURL) {
          this.getVideoThumbnail()
      }
      if(val) {
        window._paq.push(['setDocumentTitle', this.agenda.title]);
        window._paq.push(['trackPageView']);
        userApi.logUserAccessContent({
          "idContent": this.agenda.idContent,
          "idUser": this.$store.getters.user.idUser,
          "idUserAccessContent":""
        })
      }
    }
  },
  methods: {
    openLinksInNewTab: openLinksInNewTab,
    getAgendaEvent() {
      this.$store.dispatch('getAgendaEvent', {_embed: 1, idAgendaEntry: this.$route.params.id})
    },
    openPopup (e, popup) {
      e.preventDefault()
      if (popup === 'video') {
        this.popupVideo = 1
      } else if (popup === 'form') {
        this.contactForm.subject = `Request contact - ${this.agenda.title}`
        this.popupForm = 1
      }
      document.querySelector('body').classList.add('nooverflow')
    },
    closePopup (popup) {
      if (popup === 'video') {
        this.popupVideo = 0
      } else if (popup === 'form') {
        this.popupForm = 0
      }
      document.querySelector('body').classList.remove('nooverflow')
    },
    sendMessage(e) {
      e.preventDefault()
      let data = {
        ...this.contactForm,
        addresses: this.agenda.email,
        idUser: this.$store.getters.user.idUser
      }

      if(settings.ENV === 'STAGE') {
        data.addresses = ['helena.rozko@capgemini.com', 'joanna.lebica@capgemini.com']
        data.subject = `STAGE: ${data.subject}`
      }
      api.sendEmail(data, () => {
        this.contactForm = {
          subject: '',
          content: ''
        }
        this.closePopup('form')
      })
    },
    getVideoThumbnail() {
      let yt_rx = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      let matches = this.agenda.videoURL.match(yt_rx)
      if(matches) {
        this.setYTThumbnail(matches[5])
      }

      let vm_rx = /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/;
      if(this.agenda.videoURL.match(vm_rx))      {
        this.setVimeoThumbnail()
      }
    },
    setVimeoThumbnail() {
      vimeo.getThumbnail(this.agenda.videoURL, (response) => {
        this.thumbnail = response.thumbnail_url
        this.videoIframe = response.html
      })
    },
    setYTThumbnail(videoId) {
      this.videoIframe = `<iframe id="ytplayer" type="text/html" width="640" height="360"
                           src="https://www.youtube.com/embed/${videoId}?autoplay=1"
                           frameborder="0"/>`
      this.thumbnail = `https://i1.ytimg.com/vi/${videoId}/maxresdefault.jpg`
    },
    downloadIcs() {
      ics.createEvent({
        start: this.formatDateTimeArray(this.agenda.startDate, this.agenda.timezone),
        startInputType: 'local',
        end:  this.formatDateTimeArray(this.agenda.endDate, this.agenda.timezone),
        endInputType: 'local',
        title: this.agenda.title,
        organizer: { name: this.$store.getters.company.name, email: this.agenda.email },
        htmlContent: this.encodeHTML(this.agenda.subject),
      }, (error, value) => {
        if (error) {
          console.log(error)
        }
        if (value) {
          window.open( "data:text/calendar;charset=utf8," + escape(value));
        }
      });
    },
    encodeHTML(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      const allElements = div.childNodes;
      for (const element of allElements) {
        this.htmlEntityFormat(element)
      }
      let html2 = (div.outerHTML || new XMLSerializer().serializeToString(div)).replace(/&amp;/g, "&")
      return html2
    },
    formatDateTimeArray(date, timezone) {
      let dateTime = moment.tz(date, timezone).tz(moment.tz.guess())
      return [
        Number(dateTime.format('YYYY')),
        Number(dateTime.format('M')),
        Number(dateTime.format('D')),
        Number(dateTime.format('H')),
        Number(dateTime.format('mm')),
      ]
    },
    htmlEntityFormat(element) {
      if(element.nodeType !== 3) {
        for (const childElement of element.childNodes) {
          if(childElement.nodeName === 'FIGURE') {
            element.removeChild(childElement)
            continue;
          }
          this.htmlEntityFormat(childElement)
        }
      } else {
        let text = element.textContent.replace(/;/g, "$q$");
        text = he.encode(text, {'decimal': true})
        element.textContent = text.replace(/;/g, "").replace(/\$q\$/g, ";").replace(/&#9/g, "   ")
      }
    }
  }
}
</script>
